import axios from 'axios'
import {AuthModel, UserModel} from './_models'

const API_URL = process.env.REACT_APP_API_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/verify_token`
export const LOGIN_URL = `${API_URL}/login`
export const REGISTER_URL = `${API_URL}/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`

// Server should return AuthModel
export function login(password: string) {
  return axios.post<AuthModel>(LOGIN_URL, {
    password
  })
}

// Server should return AuthModel
export function register(
  id: number,
  email: string,
  firstname: string,
  lastname: string,
  mobile: string,
  wallet: string,
  amount: string
) {
  return axios.post(REGISTER_URL, {
    id,
    email,
    first_name: firstname,
    last_name: lastname,
    mobile: mobile,
    wallet,
    amount,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    email,
  })
}

export function getUserByToken(token: string) {
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    api_token: token,
  })
}

export function getUserEmpty() {
  const user: UserModel = {
    id: 0, 
    email: "", 
    first_name: "", 
    last_name: "", 
    mobile: "", 
    wallet: "", 
    amount: "",
  }
  return user
}
